import { FC, useEffect, useState } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useWxWork, sign } from '@cloud/wxwork-workbench';
import Toast from '@/components/Toast';
import BasicLayout from '@/layouts/basic';
import { makeSignature } from '@/services';
import IndexPage from './index';
import TodoReminder from './todo-reminder';
import AddFriendTasks from './add-friend-tasks';
import SOP from './sop';
import Moments from './moments'


const signOnLocationChanged = async (corpId: string, callback: () => void) => {
  try {
    await sign(corpId, {
      requests: {
        makeSignature,
        makeAgentSignature: id => makeSignature(id, true)
      },
      apiLists: {
        onHistoryBack: false,
        selectExternalContact: true,
        openUserProfile: true,
        shareToExternalContact: true,
        shareToExternalChat: true,
        openEnterpriseChat: true,
        shareToExternalMoments: true
      }
    });
    callback();
  } catch (e) {
    if (process.env.REACT_APP_API === 'production') {
      console.log(e);
    } else {
      alert(JSON.stringify(e));
    }
    Toast.error('企业微信配置失败');
  }
}

const BasicRoutes: FC = () => {
  const { pathname, search } = useLocation();
  const { corpId, userId } = useWxWork();
  const [initialized, init] = useState<boolean>(false);

  useEffect(() => {
    if (corpId) {
      signOnLocationChanged(corpId, () => init(true));
    }
  }, [pathname, search, corpId]);

  return (initialized && corpId && userId) ? (
    <Switch>
      <Route exact path='/'>
        <IndexPage />
      </Route>
      <Route path='/todo-reminder'>
        <Switch>
          <Route path='/todo-reminder/:status'>
            <TodoReminder />
          </Route>
          <Route path='/todo-reminder'>
            <TodoReminder />
          </Route>
        </Switch>
      </Route>
      <Route path='/add-friend-tasks'>
        <AddFriendTasks />
      </Route>
      <Route path='/sop'>
        <SOP />
      </Route>
      <Route path='/moments'>
        <Moments />
      </Route>
      <Redirect to='/' />
    </Switch>
  ) : (
    <BasicLayout loading />
  );
}

export default BasicRoutes;
